import { createAsyncThunk } from "@reduxjs/toolkit";
import get from "lodash/get";

export const getApi = createAsyncThunk(
  "allGetApi",
  async (action, { getState, extra, rejectWithValue }) => {
    try {
      const { api } = extra;
      const { token } = get(getState(), "auth");
      const { endpoint } = action;

      const result = await api.get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return result;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || { message: "Request failed" }
      );
    }
  }
);

export const postApi = createAsyncThunk(
  "allPostApi",
  async (action, { getState, extra, rejectWithValue }) => {
    try {
      const { api } = extra;
      const { token } = get(getState(), "auth");
      const { endpoint, payload } = action;

      const result = await api.post(endpoint, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return result;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || { message: "Request failed" }
      );
    }
  }
);

export const patchApi = createAsyncThunk(
  "allPatchApi",
  async (action, { getState, extra, rejectWithValue }) => {
    try {
      const { api } = extra;
      const { token } = get(getState(), "auth");
      const { endpoint, payload } = action;

      const result = await api.patch(endpoint, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return result;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || { message: "Request failed" }
      );
    }
  }
);

export const deleteApi = createAsyncThunk(
  "allDeleteApi",
  async (action, { getState, extra, rejectWithValue }) => {
    try {
      const { api } = extra;
      const { token } = get(getState(), "auth");
      const { endpoint } = action;

      const result = await api.delete(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return result;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || { message: "Request failed" }
      );
    }
  }
);
